import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { Box, Card, Button, Typography, Alert, Link, IconButton, Tooltip } from '@mui/material';
import TranslateIcon from '@mui/icons-material/Translate';
import { isLoggedIn } from '../utils/auth';
import { useI18n } from '../utils/i18n';

// New-customer registration is PAUSED. This page no longer renders a signup
// form; it shows a "contact for access" message. Re-enable by restoring the
// form from git history and re-enabling the backend /register + /verify_email
// endpoints (web_api.py).
const CONTACT_EMAIL = 'soraneyamasaki@gmail.com';

export default function RegisterPage() {
  const navigate = useNavigate();
  const { t, lang, toggleLang } = useI18n();

  if (isLoggedIn()) { navigate('/dashboard', { replace: true }); return null; }

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'background.default' }}>
      <Card sx={{ p: { xs: 3, sm: 4 }, width: { xs: '90%', sm: 380 }, maxWidth: 380, position: 'relative' }}>
        <Tooltip title={lang === 'en' ? '切换中文' : 'Switch to English'}>
          <IconButton size="small" onClick={toggleLang} sx={{ position: 'absolute', top: 12, right: 12, color: 'text.secondary' }}>
            <TranslateIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        <Typography variant="h5" color="primary" gutterBottom>
          {lang === 'zh' ? '暂停注册' : 'Registration Paused'}
        </Typography>
        <Alert severity="info" sx={{ mb: 2 }}>
          {lang === 'zh'
            ? '目前暂不开放新用户注册。'
            : 'New-customer registration is currently paused.'}
        </Alert>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          {lang === 'zh' ? '如需开通账号，请联系：' : 'For access, please contact:'}{' '}
          <Link href={`mailto:${CONTACT_EMAIL}`} color="primary">{CONTACT_EMAIL}</Link>
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center' }}>
          {t('register.hasAccount')}{' '}
          <Link component={RouterLink} to="/login" color="primary">{t('register.signIn')}</Link>
        </Typography>
        <Button
          variant="text"
          fullWidth
          size="small"
          onClick={() => navigate('/dashboard')}
          sx={{ mt: 1, color: 'text.secondary', textTransform: 'none' }}
        >
          {t('login.continueAsGuest') || 'Continue as guest (limited access)'}
        </Button>
      </Card>
    </Box>
  );
}
